export class InputBase {
    cmd: string
}